import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class Logo extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <svg
                    version="1.1"
                    className={this.props.className}
                    width={this.props.width}
                    height={this.props.height}
                    id="logo"
                    x="0px"
                    y="0px"
                    viewBox="0 0 188.4 216"
                    style={{ enableBackground: 'new 0 0 188.4 216' }}
                >
                    <g>
                        <linearGradient
                            id="SVGID_1_"
                            gradientUnits="userSpaceOnUse"
                            x1="2.1246"
                            y1="134.6706"
                            x2="94.1392"
                            y2="134.6706"
                        >
                            <stop offset="1.716441e-02" style={{ stopColor: '#4CC8F2' }} />
                            <stop offset="0.2221" style={{ stopColor: '#46C3EC' }} />
                            <stop offset="0.4638" style={{ stopColor: '#33B8E1' }} />
                            <stop offset="0.724" style={{ stopColor: '#00A7CF' }} />
                            <stop offset="0.9957" style={{ stopColor: '#008FB6' }} />
                            <stop offset="1" style={{ stopColor: '#008FB6' }} />
                        </linearGradient>
                        <polygon fill={'url(#SVGID_1_)'} points="94.1,108.1 2.1,54.7 2.1,161.2 94.1,214.6 	" />
                        <linearGradient
                            id="SVGID_2_"
                            gradientUnits="userSpaceOnUse"
                            x1="94.2071"
                            y1="-5.0968"
                            x2="94.2071"
                            y2="118.6621"
                        >
                            <stop offset="1.716441e-02" style={{ stopColor: '#4CC8F2' }} />
                            <stop offset="0.2221" style={{ stopColor: '#46C3EC' }} />
                            <stop offset="0.4638" style={{ stopColor: '#33B8E1' }} />
                            <stop offset="0.724" style={{ stopColor: '#00A7CF' }} />
                            <stop offset="0.9957" style={{ stopColor: '#008FB6' }} />
                            <stop offset="1" style={{ stopColor: '#008FB6' }} />
                        </linearGradient>
                        <polygon fill={'url(#SVGID_2_)'} points="186.3,54.7 94.1,1.4 2.1,54.7 94.1,108.1 	" />
                        <linearGradient
                            id="SVGID_3_"
                            gradientUnits="userSpaceOnUse"
                            x1="105.3547"
                            y1="154.7757"
                            x2="212.8547"
                            y2="92.7757"
                        >
                            <stop offset="1.716441e-02" style={{ stopColor: '#4CC8F2' }} />
                            <stop offset="0.2221" style={{ stopColor: '#46C3EC' }} />
                            <stop offset="0.4638" style={{ stopColor: '#33B8E1' }} />
                            <stop offset="0.724" style={{ stopColor: '#00A7CF' }} />
                            <stop offset="0.9957" style={{ stopColor: '#008FB6' }} />
                            <stop offset="1" style={{ stopColor: '#008FB6' }} />
                        </linearGradient>
                        <polygon fill={'url(#SVGID_3_)'} points="94.1,214.6 186.3,161.2 186.3,54.7 94.1,108.1 	" />
                    </g>
                </svg>
            </div>
        );
    }
}

// Logo.propTypes = {
//   width: PropTypes.number,
//   height: PropTypes.number
// };



// WEBPACK FOOTER //
// ./src/shared/logo.js